// @flow
const acceptedTypes: Array<string> = [
  'pesquisa',
  'checklist',
  'monitoria'
];

function beforeEnter(from: Object, to: Object, next: Function) {
  if (acceptedTypes.includes(from.params.type)) {
    next();
  } else {
    next({ name: 'FormChooser' });
  }
}

export default {
  path: '/formularios',
  component: () => import('modules/form/Index.vue'),
  children: [
    {
      path: '',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Formulários',
            name: 'FormChooser'
          }
        ]
      },
      name: 'FormChooser',
      component: () => import('modules/form/Choose.vue')
    },
    {
      path: ':type/novo',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Formulários',
            name: 'FormChooser'
          }
        ]
      },
      name: 'FormNew',
      component: () => import('modules/form/new/New'),
      beforeEnter
    },
    {
      path: ':type/',
      meta: {
        breadcrumbs: [
          {
            name: 'Dashboard',
            text: 'Novo Smart'
          },
          {
            text: 'Visitas',
            name: 'Visit'
          },
          {
            text: 'Formulários',
            name: 'FormChooser'
          }
        ],
        savePositionFrom: 'FormView'
      },
      name: 'FormList',
      component: () => import('modules/form/list/List.vue'),
      beforeEnter,
      children: [
        {
          path: ':id',
          meta: {
            breadcrumbs: [
              {
                name: 'Dashboard',
                text: 'Novo Smart'
              },
              {
                text: 'Visitas',
                name: 'Visit'
              },
              {
                text: 'Formulários',
                name: 'FormChooser'
              }
            ],
            savePositionFrom: 'FormList'
          },
          name: 'FormView',
          component: () => import('modules/form/list/view/View.vue'),
          beforeEnter
        }
      ]
    }
  ]
};
